import { el } from 'redom';

import reminderUnits from 'constants/reminder-units';

import SingleSelectInputBox from 'generics/components/single-select/native/input-box';

import {
  findIndexByPropertyValue
} from 'utilities/collection';

import { stringToSVG } from 'utilities';

import closeButtonIconString from 'assets/images/close-button-icon.svg?raw';

const closeButtonIcon = stringToSVG(closeButtonIconString);

class ReminderInput {

  constructor(remindersInput) {

    this.reminder = {
      value: 10,
      unit: reminderUnits.MINUTES
    };
    this.index = -1;
    this.remindersInput = remindersInput;

    this.valueInput = new SingleSelectInputBox(this.buildValueInputOptions());
    this.unitInput = new SingleSelectInputBox(this.buildUnitInputOptions());
    this.label = el('label', 'before');
    this.deleteButton = el('button', {
      class: 'application-button round-button reminder-delete-button',
      onclick: this.handleDeleteClick.bind(this)
    }, [closeButtonIcon.cloneNode(true)]);

    this.el = el('.reminder-input-main', [
      this.valueInput,
      this.unitInput,
      this.label,
      this.deleteButton
    ]);

  }

  getMinuteValueInputOptions() {

    const options = [];

    let startIndex = 10;
    let step = 5;

    if (import.meta.env.NODE_ENV === 'development') {
      startIndex = 1;
      step = 1;
    }

    for (let index = startIndex; index < 60; index += step) {
      options.push({
        label: index.toString(),
        value: index
      });
    }

    return options;

  }

  getHourValueInputOptions() {

    const options = [];

    for (let index = 1; index < 24; index++) {

      options.push({
        label: index.toString(),
        value: index
      });

    }

    return options;

  }

  getDayValueInputOptions() {

    const options = [];

    for (let index = 1; index < 31; index++) {

      options.push({
        label: index.toString(),
        value: index
      });

    }

    return options;

  }

  getValueInputOptions() {

    const unit = this.reminder.unit;

    if (unit === reminderUnits.MINUTES) {
      return this.getMinuteValueInputOptions();
    } else if (unit === reminderUnits.HOURS) {
      return this.getHourValueInputOptions();
    } else if (unit === reminderUnits.DAYS) {
      return this.getDayValueInputOptions();
    } else {
      return this.getWeekValueInputOptions();
    }

  }

  getSelectedValueIndices() {

    const index = findIndexByPropertyValue(this.getValueInputOptions(), 'value', this.reminder.value);

    if (index === -1) {
      return [];
    }

    return [index];

  }

  buildValueInputOptions() {

    const options = {
      placeholder: 'Value',
      options: this.getValueInputOptions(),
      selectedOptionIndices: this.getSelectedValueIndices(),
      onChange: this.handleValueChange.bind(this)
    };

    return options;

  }

  getUnitInputOptions() {

    const options = [{
      label: 'minutes',
      value: reminderUnits.MINUTES
    }, {
      label: 'hours',
      value: reminderUnits.HOURS
    }, {
      label: 'days',
      value: reminderUnits.DAYS
    }];

    return options;

  }

  getSelectedUnitIndices() {

    const index = findIndexByPropertyValue(this.getUnitInputOptions(), 'value', this.reminder.unit);

    if (index === -1) {
      return [];
    }

    return [index];

  }

  buildUnitInputOptions() {

    const options = {
      placeholder: 'Unit',
      options: this.getUnitInputOptions(),
      selectedOptionIndices: this.getSelectedUnitIndices(),
      onChange: this.handleUnitChange.bind(this)
    };

    return options;

  }

  propogateChange() {

    this.remindersInput.handleReminderChange(this.reminder, this.index);

  }

  handleValueChange({ values }) {

    this.reminder.value = values[0];
    this.propogateChange();

  }

  handleUnitChange({ values }) {

    this.reminder.unit = values[0];

    if (this.reminder.unit === reminderUnits.WEEKS) {
      this.reminder.value = 1;
    } else if (this.reminder.unit === reminderUnits.DAYS) {
      this.reminder.value = 1;
    } else if (this.reminder.unit === reminderUnits.HOURS) {
      this.reminder.value = 1;
    } else if (this.reminder.unit === reminderUnits.MINUTES) {
      this.reminder.value = 10;
    }

    this.propogateChange();
    this.updateInputs();

  }

  handleDeleteClick() {

    this.remindersInput.removeReminder(this.index);

  }

  updateInputs() {

    this.valueInput.configure(this.buildValueInputOptions());
    this.unitInput.configure(this.buildUnitInputOptions());

  }

  update(reminder, index) {

    this.reminder = reminder;
    this.index = index;

    this.updateInputs();

  }

}

export default ReminderInput;